import { createSingleEntityStore } from '@core/ngrx-legacy';

import type { NotificationCounterStore } from '../../types';
import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<NotificationCounterStore>()(EntityStoreKey.notificationsCounter);

export {
  actions as NotificationsCounterActions,
  selectors as NotificationsCounterSelectors,
  reducer as NotificationsCounterReducer,
  namespace as NotificationsCounterNamespace,
};
